export class TipoParentezcoConstants {
  static MADRE = "Madre"
  static PADRE = "Padre"
}
